import { memo, useState, useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import Color from 'color'
import 'react-toastify/dist/ReactToastify.css'
import { useCompanySetting, useLoggedInUser } from '@/hooks'
import { theme as defaultTheme, breakpoints, mediaQueries } from './theme'
import Content from './Content'

interface ThemeProviderWrapperProps {
  unauthenticated?: boolean
  children: React.ReactNode
  onFinishedLoading?: () => void
  preloading?: boolean
}

const ThemeProviderWrapper = ({
  unauthenticated,
  children,
  onFinishedLoading,
  preloading,
}: ThemeProviderWrapperProps) => {
  const [theme, setTheme] = useState(defaultTheme)

  const [primaryColor, { loading: primaryColorLoading }] = useCompanySetting(
    'THEME_PRIMARY_COLOR',
  )

  const [secondaryFontColor, { loading: secondaryColorLoading }] =
    useCompanySetting('THEME_FONT_SECONDARY_COLOR')

  const { loading: userLoading } = useLoggedInUser(true)

  useEffect(() => {
    setTheme({
      ...defaultTheme,
      primaryColor: primaryColor || '#0a5b8b',
      secondaryColor: Color(primaryColor || '#0a5b8b')
        .darken(0.3)
        .string(),
      secondaryFontColor: secondaryFontColor || '#fff',
    })
  }, [primaryColor, secondaryFontColor])

  const loadingComplete = !(
    primaryColorLoading ||
    secondaryColorLoading ||
    userLoading
  )

  useEffect(() => {
    if (loadingComplete && typeof onFinishedLoading === 'function') {
      onFinishedLoading()
    }
  }, [loadingComplete, onFinishedLoading])

  if (preloading) {
    return children
  }

  if (!loadingComplete) {
    return null
  }

  return (
    <ThemeProvider theme={{ ...theme, breakpoints, mediaQueries }}>
      <Content unauthenticated={unauthenticated}>{children}</Content>
    </ThemeProvider>
  )
}

// @ts-ignore
export default memo(ThemeProviderWrapper)
